import { render, staticRenderFns } from "./CteVeiculo.vue?vue&type=template&id=54304c2c"
import script from "./CteVeiculo.vue?vue&type=script&lang=js"
export * from "./CteVeiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports